import axios from 'axios'
import router from '@/router';

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    if (config.url.includes("v2")) {
      const tenantId = localStorage.getItem('tenant-id')
      if (tenantId) {
        config.headers["tenant-id"] = tenantId;
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const { code, data, msg } = response.data;
    if (String(code) === "200" || String(code) === "0") {
      return data;
    } if (String(code) == '401' || String(code) == '403') {
      localStorage.removeItem('token');
      router.replace('/');
    } else {
      return Promise.reject({
        message: msg || 'Error',
        status: code
      })
    }
  },
  error => {
    // 网络错误/超时处理
    if (!error.response) {
      if (error.message.includes('timeout')) {
        // ElMessage.error('请求超时，请稍后重试');
      } else {
        // ElMessage.error('网络异常，请检查网络连接');
      }
      return Promise.reject(error);
    }
    // 后端返回错误码处理
    const { status, data } = error.response;
    switch (status) {
      case 401:
        // 未登录，跳转登录页面
        router.replace('/');
        break
      case 403:
        // 权限不足，token 过期，清除 token 并跳转登录页面
        localStorage.removeItem('token');
        router.replace('/');
        break
      case 404:
        // 请求不存在
        break
      case 500:
        // 服务器内部错误
        break
      case 506:
        // 无
        break;
      default:
      // 其他错误
    }
    return Promise.reject(error);
  }
)

export default request
